import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { RenderViewLensParams } from '@upright/common/renderer/component-types/types-render-view-lenses';
import { useGetRenderViewNetImpactLensData } from './use-get-render-view-net-impact-lens-data';
import { RenderViewLens } from '../render-view-lens';
import { NetImpactLensOptions } from '@upright/ui/common/upright/core/impact-lenses/net-impact/types';

export const RenderViewNetImpactLens = (props: { params: RenderViewLensParams }) => {
  const { params } = props;
  const lensType = ImpactLensType.UPRIGHT_NET_IMPACT;
  const lensData = useGetRenderViewNetImpactLensData(params.item);
  const lensOptions: Partial<NetImpactLensOptions> = {
    disableValueSetSelector: true,
    hideSuggestFixes: true,
    hideRenderViewButton: true,
    disableLinks: true,
    disableResponsiveBoxMode: true,
  };
  return <RenderViewLens lensType={lensType} lensData={lensData} params={params} lensOptions={lensOptions} />;
};
